module.exports = __webpack_public_path__ + "img/customer-service-fr.b12b9750.svg";